/**
 *
 * appJumpType 1 app打开导学页 2 演示类  3 打开小程序 4 题库
 *
 */
// miniJumpType 1 下载app弹窗  2 打开导学页 3演示类 4 打开小程序

// h5JumpType 1 下载app弹窗  2 打开导学页 3演示类 4 打开小程序  5 打开题库

const serviceList = {
  1: {
    appBtnName: '前往体验', // 每日任务
    appJumpType: 1,
    miniBtnName: '前往“启航教育”app体验',
    miniJumpType: 1,
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
  },
  2: {
    appBtnName: '前往体验', // 同步测试
    appJumpType: 1,
    miniBtnName: '前往“启航教育”app体验',
    miniJumpType: 1,
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
  },
  3: {
    appBtnName: '前往体验', // 视频要点
    appJumpType: 1,
    miniBtnName: '前往“启航教育”app体验',
    miniJumpType: 1,
    h5BtnName: '前往体验',
    h5JumpType: 2,
  },
  4: {
    appBtnName: '前往体验', // 学习笔记
    appJumpType: 1,
    miniBtnName: '前往“启航教育”app体验',
    miniJumpType: 1,
    h5BtnName: '前往体验',
    h5JumpType: 2,
  },
  5: {
    appBtnName: '前往体验', // 学习报告
    appJumpType: 1,
    miniBtnName: '前往体验',
    miniJumpType: 2,
    h5BtnName: '前往体验',
    h5JumpType: 2,
  },
  6: {
    appBtnName: '前往体验', // 人工答疑
    appJumpType: 2,
    miniBtnName: '前往体验',
    miniJumpType: 3,
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-answer.gif',
    h5BtnName: '前往体验',
    h5JumpType: 3,
  },
  7: {
    appBtnName: '前往体验', // 人工批改
    appJumpType: 2,
    miniBtnName: '前往体验',
    miniJumpType: 3,
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-check.gif',
    h5BtnName: '前往体验',
    h5JumpType: 3,

  },
  8: {
    appBtnName: '前往体验', // 张宇刷题
    appJumpType: 3,
    miniBtnName: '前往体验',
    miniJumpType: 4,
    miniPath: '/zhangyuPractice/home/index',
    h5BtnName: '前往体验',
    h5JumpType: 4,
  },
  9: {
    appBtnName: '前往体验', // 知识点练习
    appJumpType: 2,
    miniBtnName: '前往体验',
    miniJumpType: 3,
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-ponit.gif',
    h5BtnName: '前往体验',
    h5JumpType: 3,
  },
  10: {
    appBtnName: '前往体验', // 智能组卷
    appJumpType: 2,
    miniBtnName: '前往体验',
    miniJumpType: 3,
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-exam.gif',
    h5BtnName: '前往体验',
    h5JumpType: 3,
  },
  11: {
    appBtnName: '前往体验', // 单词训练
    appJumpType: 3,
    miniBtnName: '前往体验',
    miniJumpType: 4,
    miniPath: '/pages/chooseLogin/chooseLogin',
    h5BtnName: '前往体验',
    h5JumpType: 4,
  },
  12: {
    appBtnName: '前往体验', // 长难句
    appJumpType: 3,
    miniBtnName: '前往体验',
    miniJumpType: 4,
    miniPath: '/longSentences/list/list',
    h5BtnName: '前往体验',
    h5JumpType: 4,
  },
  13: {
    appBtnName: '前往体验', // 阅读专项
    appJumpType: 2,
    miniBtnName: '前往体验',
    miniJumpType: 3,
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-read.gif',

  },
  14: {
    appBtnName: '前往体验', // 写作专项
    appJumpType: 2,
    miniBtnName: '前往体验',
    miniJumpType: 3,
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-write.gif',
    h5BtnName: '前往体验',
    h5JumpType: 3,
  },
  15: {
    appBtnName: '前往体验', // 政治千题练主页
    appJumpType: 3,
    miniPath: '/zhangyuPractice/politics/index',
    miniBtnName: '前往体验',
    miniJumpType: 4,
  },
  16: {
    appBtnName: '前往体验', // 扫码听课
    appJumpType: 2,
    miniBtnName: '前往体验',
    miniJumpType: 3,
    miniPath: '/zhangyuPractice/politics/index',
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-scCode.gif',
    h5BtnName: '前往体验',
    h5JumpType: 3,

  },
  17: {
    appBtnName: '前往体验', // 阶段测试
    appJumpType: 1,
    miniBtnName: '前往“启航教育”app体验',
    miniJumpType: 1,
    h5BtnName: '前往“启航教育”app体验',
    h5JumpType: 1,
  },
  18: {
    appBtnName: '前往体验', // 社群伴学
    appJumpType: 2,
    miniBtnName: '前往体验',
    miniJumpType: 3,
    miniPath: '/zhangyuPractice/politics/index',
    img: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/vipProduct/show-qq.gif',
    h5BtnName: '前往体验',
    h5JumpType: 3,
  },
  19: {
    appBtnName: '前往体验', // 题库练习
    appJumpType: 4,
    miniBtnName: '前往体验',
    miniJumpType: 5,
    miniPath: '/pages/questions/questions',
    h5BtnName: '前往体验',
    h5JumpType: 5,
  },
  20: {
    appBtnName: '前往体验', // 作文批改
    appJumpType: 3,
    miniBtnName: '前往体验',
    miniJumpType: 4,
    miniPath: '/correction/home/index',
    h5BtnName: '前往体验',
    h5JumpType: 4,
  },
};
export default serviceList;



/**
 *
    // miniBtnName: '前往“启航教育”app体验',
    // miniType: 1,
    // miniJumpType: 1,
    // guideImg: [],
 */
